import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { PipesModule } from './pipes/pipes.module';

import { LayoutComponent } from './layout/layout.component';
import { MenuComponent } from './menu/menu.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

import { AuthService } from './auth.service';
import { LanguageService } from './language.service';
import { AuthenticatedGuard } from './authenticated.guard';
import { NotAuthenticatedGuard } from './not-authenticated.guard';
import { ExpiredGuard } from './expired.guard';
import { UserService } from './api/user.service';
import { AppService } from './api/app.service';
import { DataPackageService } from './api/data-package.service';
import { InspectionsResultsService } from './api/inspections-results.service';
import { InspectionCubesService } from './api/inspection-cubes.service';
import { FavoritesService } from './api/favorites.service';
import { KmlsService } from './api/kmls.service';
import { ColorsService } from './api/colors.service';
import { FilterService } from './api/filter.service';
import { SelectionService } from './api/selection.service';
import { SelectionScheduledService } from './api/selections-scheduled.service';
import { SettingService } from './api/setting.service';
import { CategoryService } from './api/category.service';
import { PatternService } from './api/pattern.service';
import { NetworkLevelService } from './api/network-level.service';
import { RiskAreaService } from './api/risk-area.service';
import { UcService } from './api/uc.service';
import { InvoiceService } from './api/invoice.service';
import { DataQualityService } from './api/data-quality.service';
import { AppsInstalledChangeService } from './appsInstalled-change.service';
import { ApiService } from './api.service';
import { NotificationService } from './api/notification.service';
import { RiskService } from './risk.service';
import { PermissionGroupService } from './api/permission-groups.service';
import { IndicatorGoalsService } from './api/indicator-goals.service';
import { UCClassification, UCClassificationService } from './api/uc-classification.service';
import { ParametersService } from './api/parameters.service';
import { CustomStoreService } from './custom-store.service';
import { CpProfilesService } from './api/cp-profiles.service';
import { AuthorizedGuard } from './authorized.guard';
import { Helper } from './helpers/helper';
import { ChannelService } from './api/channel.service';
import { ScoringsService } from './api/scorings.service';
import { BillingMeasurementNoteService } from './api/billing-measurement-note.service';
import { SnrResponseJustificationService } from './api/snr-response-justification.service';
import { Ri5ApiService } from './ri5-api/ri5-api.service';
import { Ri5UcsService } from './ri5-api/ucs/ri5-ucs.service';

@NgModule({
  imports: [
    FormsModule,
    HttpModule,
    RouterModule,
    CommonModule,
    TranslateModule,
    PipesModule
  ],
  declarations: [
    LayoutComponent,
    MenuComponent,
    PageNotFoundComponent
  ],
  exports: [
    LayoutComponent
  ],
  providers: [
    NotAuthenticatedGuard,
    AuthenticatedGuard,
    AuthorizedGuard,
    ExpiredGuard,
    AuthService,
    UserService,
    AppService,
    DataPackageService,
    InspectionsResultsService,
    InspectionCubesService,
    FavoritesService,
    KmlsService,
    ColorsService,
    FilterService,
    CategoryService,
    PatternService,
    UcService,
    BillingMeasurementNoteService,
    NetworkLevelService,
    RiskAreaService,
    InvoiceService,
    DataQualityService,
    SettingService,
    LanguageService,
    AppsInstalledChangeService,
    ApiService,
    RiskService,
    PermissionGroupService,
    NotificationService,
    IndicatorGoalsService,
    UCClassificationService,
    ParametersService,
    Helper,
    CustomStoreService,
    CpProfilesService,
    ChannelService,
    ScoringsService,
    SnrResponseJustificationService,
    Ri5UcsService
  ]
})
export class CoreModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        AuthService,
        UserService,
        AppService,
        DataPackageService,
        SettingService,
        InspectionsResultsService,
        InspectionCubesService,
        FavoritesService,
        KmlsService,
        ColorsService,
        FilterService,
        SettingService,
        SelectionService,
        SelectionScheduledService,
        CategoryService,
        PatternService,
        UcService,
        BillingMeasurementNoteService,
        NetworkLevelService,
        RiskAreaService,
        InvoiceService,
        DataQualityService,
        LanguageService,
        AppsInstalledChangeService,
        ApiService,
        RiskService,
        ScoringsService,
        IndicatorGoalsService,
        UCClassificationService,
        ParametersService,
        CustomStoreService,
        Helper,
        Ri5ApiService
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts